import { render, staticRenderFns } from "./trsIndex.vue?vue&type=template&id=b8c258a8&scoped=true"
import script from "./trsIndex.vue?vue&type=script&lang=js"
export * from "./trsIndex.vue?vue&type=script&lang=js"
import style0 from "./trsIndex.vue?vue&type=style&index=0&id=b8c258a8&prod&lang=css"
import style1 from "./trsIndex.vue?vue&type=style&index=1&id=b8c258a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c258a8",
  null
  
)

export default component.exports